module.exports = __webpack_public_path__ + "static/media/intro_title.0ca3b640.webp";